export default "__VITE_ASSET__489a706a__"